import { render, staticRenderFns } from "./marketing_operations_home.vue?vue&type=template&id=6d88b6aa&scoped=true&"
import script from "./marketing_operations_home.vue?vue&type=script&lang=js&"
export * from "./marketing_operations_home.vue?vue&type=script&lang=js&"
import style0 from "./marketing_operations_home.vue?vue&type=style&index=0&id=6d88b6aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88b6aa",
  null
  
)

export default component.exports